
import {defineComponent} from "vue";
import {ProductFilterConditionRestDto} from "@/api/pharma-cpc-mgmt/models";
import {PropType} from "vue/dist/vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import ProductList from "@/components/UI/product/ProductList.vue";
import {ProductListSelectionDto} from "@/components/UI/product/ProductListSelectionDto";

export default defineComponent({
  name: "ProductFilterConditionAll",
  components: {
    ProductList,
    BaseDeleteButton
  },
  emits: ['update:modelValue', 'filterRemoved'],
  props: {
    modelValue: {
      type: Object as PropType<ProductFilterConditionRestDto>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cnkCodes: [] as string[],
      productCodes: [] as string[]
    }
  },
  mounted() {
    this.syncFromModelValue();
  },
  watch: {
    modelValue() {
      this.syncFromModelValue();
    }
  },
  methods: {
    syncFromModelValue(): void {
      this.cnkCodes = [...this.modelValue.cnk_codes_excluded ?? []];
      this.productCodes = [...this.modelValue.product_codes_excluded ?? []];
    },
    removeCondition(): void {
      this.$emit('filterRemoved');
    },
    updateExcludedProducts(value: ProductListSelectionDto): void {
      this.cnkCodes = value.cnkCodes;
      this.productCodes = value.productCodes;
      this.$emit('update:modelValue', {
        ...this.modelValue,
        cnk_codes_excluded: this.cnkCodes,
        product_codes_excluded: this.productCodes
      });
    }
  },
  computed: {
    productSelection(): ProductListSelectionDto {
      return {
        cnkCodes: this.cnkCodes,
        productCodes: this.productCodes
      };
    },
  }
});
